import React from 'react';
import { Box } from '@material-ui/core';
import { Lock as LockIcon } from '@material-ui/icons';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(theme => ({
  circleContainer: {
    backgroundColor: theme.palette.error.light,
    marginBottom: theme.spacing(3),
    borderRadius: '50%',
    width: '80px',
    height: '80px',
  },
  deleteIcon: {
    color: '#fff',
  },
  textContainer: {
    textAlign: 'center',
    lineHeight: 2,
  },
}));

const ConfirmationSaveFinal = () => {
  const classes = useStyles();

  return (
    <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center">
      <Box display="flex" className={classes.circleContainer} justifyContent="center" alignItems="center">
        <LockIcon className={classes.deleteIcon} fontSize="large" />
      </Box>
      <div className={classes.textContainer}>
        <p>
          You have made changes to a Cap Table that is being used in a Allocation marked as final. These changes will
          alter the final allocation.
        </p>
      </div>
    </Box>
  );
};

export default ConfirmationSaveFinal;
